import { Controller } from "@hotwired/stimulus"
import jQuery from "jquery"
import "datatables.net-dt"

export default class extends Controller {
  static targets = ["table", "toggleButton"]

  connect() {
    const $table = jQuery(this.tableTarget)
    this.table = $table.DataTable({
      paging: false,
      autoWidth: false,
      columnDefs: [
        { orderable: false, targets: -1 } // Actions column
      ]
    })

    this.detailColumns = []
    this.checkpointColumns = []

    this.tableTarget.querySelectorAll("thead th").forEach((th, idx) => {
      const type = th.dataset.columnType
      if (type === "details") this.detailColumns.push(idx)
      if (type === "checkpoint") this.checkpointColumns.push(idx)
    })

    this.showingCheckpoints = false

    this.checkpointColumns.forEach(idx => {
      this.table.column(idx).visible(false)
    })
  }

  toggleCheckpoints() {
    this.showingCheckpoints = !this.showingCheckpoints

    this.detailColumns.forEach(idx => {
      this.table.column(idx).visible(!this.showingCheckpoints)
    })

    this.checkpointColumns.forEach(idx => {
      this.table.column(idx).visible(this.showingCheckpoints)
    })

    this.toggleButtonTarget.textContent = this.showingCheckpoints
      ? "Hide checkpoint times"
      : "Show checkpoint times"
  }

  disconnect() {
    if (this.table) this.table.destroy()
  }
}
